<template>
  <div>
    <h2>{{ $t('title.users') }}</h2>

    <base-list
    model="users"
    :columns="['first_name', 'email']"
    s-model="user"
    />
  </div>
</template>

<script>
import BaseList from 'components/BaseList'

export default {
  name: 'user-list',
  components: { BaseList }
}
</script>



// WEBPACK FOOTER //
// UserList.vue?7fcae771